import { IS_WEB } from 'constants/platform'
import React from 'react'

import { GroupInfo } from 'partials/GroupInfo/GroupInfo'

import { Box } from 'widgets/Box'
import { CollapsibleSection } from 'widgets/CollapsibleSection'

import { useUser } from 'hooks/useUser'

import { defaultPostThumbnailUrl } from 'utils/media'

import { Program } from 'types/program'

type ProgramGroupsSectionProps = {
  program?: Program
}

export const ProgramGroupsSection = ({ program }: ProgramGroupsSectionProps) => {
  const { data: creator } = useUser({ userId: program?.trainer?.id })

  const creatorAvatar = (IS_WEB ? creator?.avatar?.url : creator?.avatar) ?? defaultPostThumbnailUrl

  return (
    <CollapsibleSection
      sectionTitle='Groups this Program lives in'
      bodyContent={
        <Box margin={{ top: 'sm' }}>
          <GroupInfo
            withImage
            withCheckbox
            imageSource={creatorAvatar}
            isChecked={false}
            title={program?.title ?? ''}
            subtitle={`${creator?.firstName ?? ''} ${creator?.lastName ?? ''}`}
          />
        </Box>
      }
    />
  )
}
